import { render, staticRenderFns } from "./AbonementsProlongating.vue?vue&type=template&id=f2ab0d9c&"
import script from "./AbonementsProlongating.vue?vue&type=script&lang=js&"
export * from "./AbonementsProlongating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports